import React from "react";
import { Sparkles, Check, X } from "lucide-react";
import { Button } from "../ui/button";

export default function AiProposta({ inv, canWrite, onConferma, onRifiuta }) {
  const p = inv.ai_proposta;
  if (inv.ai_abbinata && p?.stato === "applicata_auto") {
    return <div className="text-[10px] text-violet-700 flex items-center gap-1 mt-0.5" title={p.motivo} data-testid="ai-badge-auto"><Sparkles className="w-3 h-3" />Abbinata da AI{p.livello === "voce" && p.voce_nome ? ` · ${p.voce_nome}` : ""} ({p.confidenza}%)</div>;
  }
  if (p?.stato !== "proposta") return null;
  const target = p.livello === "voce" ? `Voce: ${p.voce_nome}${p.budget_item_id ? "" : " (nuova)"}` : p.operazione_nome ? `Operazione: ${p.operazione_nome}` : null;
  if (!target) return null;
  return (
    <div className="mt-1 flex items-center gap-1 rounded bg-violet-50 border border-violet-200 px-1.5 py-0.5 text-[11px] text-violet-800" title={p.motivo} data-testid="ai-proposta">
      <Sparkles className="w-3 h-3 shrink-0" /><span className="truncate">Proposta AI · {target} · {p.confidenza}%</span>
      {canWrite && <>
        <Button size="icon" variant="ghost" className="h-5 w-5 text-emerald-700" onClick={() => onConferma(inv)} title="Conferma" data-testid="ai-conferma"><Check className="w-3.5 h-3.5" /></Button>
        <Button size="icon" variant="ghost" className="h-5 w-5 text-slate-500" onClick={() => onRifiuta(inv)} title="Rifiuta" data-testid="ai-rifiuta"><X className="w-3.5 h-3.5" /></Button>
      </>}
    </div>
  );
}
